import type { WhitelabelConfig } from "@nlc/shared-types";
import type { UseQueryResult } from "@tanstack/react-query";

import { useQuery } from "@tanstack/react-query";

import { whitelabelKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

async function listWhitelabelConfigs(): Promise<{ data: WhitelabelConfig[] }> {
  return apiClient.url("/whitelabel/configs").get().json();
}

export function useListWhitelabelConfigs(): UseQueryResult<
  { data: WhitelabelConfig[] },
  Error
> {
  return useQuery({
    queryFn: listWhitelabelConfigs,
    queryKey: whitelabelKeys.list(),
    staleTime: 5 * 60 * 1000,
  });
}
